/** @flow */
import Estimation from 'common/modules/proposition/domain/estimation';
import type { Dispatch, GetState } from '../../../types/Store';
import SalesApi from '../services/SalesApi';
import { getStation, getToken } from '../../authentication/session/reducers/sessionReducer';

export const FETCH_ESTIMATION_HISTORY = 'sales/FETCH_ESTIMATION_HISTORY';
export const FETCH_ESTIMATION_HISTORY_SUCCESS = 'sales/FETCH_ESTIMATION_HISTORY_SUCCESS';
export const FETCH_ESTIMATION_HISTORY_ERROR = 'sales/FETCH_ESTIMATION_HISTORY_ERROR';

export const REMOVE_SALES_ESTIMATION = 'sales/REMOVE_SALES_ESTIMATION';
export const REMOVE_SALES_ESTIMATION_SUCCESS = 'sales/REMOVE_SALES_ESTIMATION_SUCCESS';
export const REMOVE_SALES_ESTIMATION_ERROR = 'sales/REMOVE_SALES_ESTIMATION_ERROR';

export function fetchEstimationHistory() {
  return async (dispatch: Dispatch, getState: GetState) => {
    dispatch({ type: FETCH_ESTIMATION_HISTORY });

    try {
      const token = getToken(getState());
      const callSign = getStation(getState());

      const history = await SalesApi.fetchHistory(token, callSign);

      dispatch({ type: FETCH_ESTIMATION_HISTORY_SUCCESS, history });
    } catch (e) {
      dispatch({ type: FETCH_ESTIMATION_HISTORY_ERROR, error: e });
    }
  };
}

export function removeSalesEstimation(estimation: Estimation) {
  return async (dispatch: Dispatch, getState: GetState) => {
    const { reference } = estimation;
    if (!reference) {
      return;
    }

    dispatch({ type: REMOVE_SALES_ESTIMATION });

    try {
      const token = getToken(getState());
      const callSign = getStation(getState());

      await SalesApi.removeSalesEstimation(token, callSign, reference);

      dispatch({ type: REMOVE_SALES_ESTIMATION_SUCCESS, estimation });
    } catch (error) {
      dispatch({ type: REMOVE_SALES_ESTIMATION_ERROR, error });
    }
  };
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/sales/actions/salesHistoryActions.js